import map from 'lodash/map'
import * as React from 'react'

import * as style from './panel-list-content.module.scss'

type Props<T> = {
  dataList: Array<T>
  renderListElement: (data: T, index: number) => React.ReactElement
}

export default function PanelListContent<T>(props: Props<T>): React.ReactElement {
  const {dataList, renderListElement} = props

  const listElements = map(dataList, (dataElement, i: number) => renderListElement(dataElement, i))

  const listBody =
    dataList.length === 0 ? (
      <div className={style.panelListContentNoDataText}>No data to show</div>
    ) : (
      listElements
    )

  return <div className={style.panelListContentContainer}>{listBody}</div>
}
